// Thin wrapper around react-toastify so every call site gets the same
// icons/options instead of re-specifying them, and so the app has one place
// to change toast behavior later.
import { toast as toastify } from "react-toastify";
import { CheckCircle2, XCircle, Info } from "lucide-react";

export const toast = {
  success: (message, options) => toastify.success(message, { icon: <CheckCircle2 size={16} />, ...options }),
  error: (message, options) => toastify.error(message, { icon: <XCircle size={16} />, ...options }),
  info: (message, options) => toastify.info(message, { icon: <Info size={16} />, ...options }),
};
